import { render, staticRenderFns } from "./SignupSectionAgreement.vue?vue&type=template&id=7202ba52"
import script from "./SignupSectionAgreement.vue?vue&type=script&lang=js"
export * from "./SignupSectionAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports